import React, {FC} from 'react'

import cn from 'classnames/bind'

import LandingsTitle from 'components/blocks/LandingsTitle'
import PortableBlocks from 'components/blocks/PortableBlocks'
import {Col, Container, Row} from 'components/elements/grid'
import {IW2Content} from 'pages/make-your-w2'

import s from './W2Filling.module.scss'
const cx = cn.bind(s)

interface IW2FillingProps {
	className?: string
	content: IW2Content['filling']
}

/** W2Filling block component */
const W2Filling: FC<IW2FillingProps> = ({className, content}) => {
	return (
		<div className={cx('wrapper', className)}>
			<Container>
				<Row>
					<Col xl={{span: 10, offset: 1}}>
						<LandingsTitle
							className={s.title}
							title={content?.title}
							subtitle={content?.subtitle}
						/>
						{content?.list && <PortableBlocks blockContent={content?.list} />}
					</Col>
				</Row>
			</Container>
		</div>
	)
}

W2Filling.displayName = 'W2Filling'

export default W2Filling
